import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from 'react-router-dom';

import { InvalidSearchImg, homePageImg } from '../../images/images';
import { Loader } from '../../UiKit';
import { useGetConfig } from './apis';
import { links } from './constants';
import { useState } from 'react';
import Sidebar from '../../UiKit/sidebar/sidebar';
import DefaultComp from './admin-action-forms/DefaultComp';
import { EmptyState } from '../../components/commons';
import { UserWidget } from '../../components/widgets';
import { useSelector } from 'react-redux';
import { hasCookieToken } from '../../utils/CookieToken';
import Auth from '../../containers/auth';

const AdminHeader = () => {
  return (
    <Header>
      <HeaderTitle>
        <Span>
          Blink
          <Span
            css={`
              color: #318616;
            `}
          >
            it
          </Span>
        </Span>
        <Span
          css={`
            font-size: 2rem;
            font-weight: 500;
          `}
        >
          Admin Dashboard
        </Span>
      </HeaderTitle>
      <div className='tw-px-6 tw-py-4 tw-border-solid  tw-border-[1px] tw-border-grey-400/80 !tw-bg-grey-100/40 tw-rounded-xl'>
        <UserWidget />
      </div>
    </Header>
  );
};

function AdminDashboard() {
  const [isNotAccessible, setIsNotAccessible] = useState(false);
  const { path } = useRouteMatch();
  const { tabSlug } = useParams();
  const { pathname } = useLocation();
  const history = useHistory();
  let FirstAccesableTabSlug = '';

  const { data: configData, isLoading } = useGetConfig({
    onSuccess: (configData) => {
      if (!configData?.tab_groups || configData?.tab_groups.length === 0) {
        setIsNotAccessible(true);
        return;
      }

      configData?.tab_groups.every((tabGroup) => {
        if (tabGroup.tabs.length > 0) {
          let found = false;
          tabGroup.tabs.every((tab) => {
            if (tab.slug === tabSlug && !tab.is_enabled) {
              setIsNotAccessible(true);
              return false;
            }
            if (tab.is_enabled && !FirstAccesableTabSlug) {
              FirstAccesableTabSlug = tab.slug;
              found = true;
              return false;
            }
            return true;
          });
          if (found) return false;
        } else {
          FirstAccesableTabSlug = tabGroup.slug;
          return false;
        }
        return true;
      });
      if (FirstAccesableTabSlug && !tabSlug) {
        history.replace(`${path}/${FirstAccesableTabSlug}`);
      }
      if (!FirstAccesableTabSlug) setIsNotAccessible(true);
    },
  });

  if (isLoading)
    return (
      <div
        css={`
          width: 100%;
          height: 100%;
          display: flex;
          align-self: center;
          justify-content: center;
        `}
      >
        <Loader />
      </div>
    );
  if (isNotAccessible && !isLoading)
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading='Oops!! You are not authorised to view this page :('
        subHeading='Reach out to your supervisor for further help.'
        imageWidth='50rem'
        maxWidth='50rem'
      />
    );
  if (configData?.tab_groups.length) {
    const CompName =
      links?.[`${tabSlug}`] || links?.[`${FirstAccesableTabSlug}`];

    return (
      <InnerContainer>
        <Sidebar
          data={configData}
          changeTab={(activeTabSlug) => {
            history.replace(pathname.replace(/[^/]*$/, activeTabSlug));
          }}
          activeTab={tabSlug || FirstAccesableTabSlug}
        />
        <CompWrapper>{CompName ? <CompName /> : <DefaultComp />}</CompWrapper>
      </InnerContainer>
    );
  }

  return (
    <EmptyState
      img={InvalidSearchImg}
      heading='Oops !! Something went wrong :('
    />
  );
}

function AdminPermissionWrapper() {
  const isAuthenticated =
    useSelector((state) => state.authState.isAuthenticated) || hasCookieToken;

  useEffect(() => {
    document.title = 'Admin Dashboard';
  }, []);

  return (
    <Container>
      {isAuthenticated ? (
        <>
          <AdminHeader />
          <AdminDashboard />
        </>
      ) : (
        <EmptyState
          img={homePageImg}
          heading='Login to blinkit'
          renderActions={() => (
            <div className='mt20'>
              <Auth title='Login to Blinkit' />
            </div>
          )}
        />
      )}
    </Container>
  );
}

export default AdminPermissionWrapper;

const Container = styled.div`
  height: 100%;
  max-height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: #f4f6fb;
  box-sizing: border-box;
  overflow-y: hidden;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const Span = styled.span`
  font-size: 3rem;
  margin-right: 0.5rem;
  font-weight: 600;
`;
const Header = styled.header`
  height: 6rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
  padding: 0.5rem;
  min-width: 100%;
  padding: 1.25rem 2rem;
  font-size: 2.4rem;
  font-weight: 500;
  box-shadow: 0px 4px 6px rgba(28, 28, 28, 0.06);
`;

const InnerContainer = styled.div`
  height: 100%;
  display: flex;
  box-sizing: border-box;
  overflow-y: auto;
`;
const CompWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 3rem;
  padding-bottom: 2rem;
  overflow-x: scroll;
  box-sizing: border-box;
`;
